export enum SalesStatusDescription {
    Pending = 1,
    Signed = 2,
    Approved = 3,
    Rejected = 4,
    Withdrawn = 5,
    OutforSignature = 6
}
